import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FileUploadButtonComponent } from '@file-upload/components/file-upload-button/file-upload-button.component';
import { FilesListComponent } from '@file-upload/components/files-list/files-list.component';
import { FileUploadDropDirective } from '@file-upload/directives/file-upload-drop.directive';
import { Attachment } from '@file-upload/models/attachment';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FilesListComponent,
    FileUploadButtonComponent,
    FileUploadDropDirective
  ]
})

// ! This is used for style-guide page
export class FileUploadComponent {
  readonly accept = input.required<string>();
  readonly multiple = input.required<boolean>();
  readonly sizeLimit = input<number>();
  readonly imageSizeLimit = input<number>();

  files: Attachment[] = [];

  filesChanged(files: File[]): void {
    const newFiles = (files || []).map<Attachment>((x: File) => ({
      url: window.URL.createObjectURL(x),
      name: x.name,
      type: x.type
    }));
    this.files = [...this.files, ...newFiles];
  }

  onDeleteFile(file: Attachment): void {
    this.files = [...this.files.filter(x => x !== file)];
  }

  //#region Getters

  get canUploadMoreFiles(): boolean {
    return this.multiple() || (this.files || []).length === 0;
  }

  //#endregion
}
